<template>
  <ChartNormal
    size="12"
    offset="0"
    title="Active Backlog"
    chart="column"
    chartType="backlog"
    :withDate="false"
    :withFinancial="false"
  />
</template>

<script>
import ChartNormal from "../../components/chart/chartNormal";

export default {
  name: "ActiveBacklog",
  components: {
    ChartNormal
  }
};
</script>
